module.exports = __webpack_public_path__ + "img/nato.7864b37c.svg";